import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    hambergerState: true,
    loadingSpinnerState: false,
    popperState: false,
    DeleteButtonDisplayState: false,
    skeletonState: false,
    dashboardPageData: {},
    pagesPathName: "/",
    setInputValue: "",
    KeyOfInputForSearch: [],
    singleKey: "",
    toastifyType: {},
    conectionFailedState: true,
    expireState: true,
    tableSkeleton: false,
    homeAdminFetchState: false,
    removeSearchExist: false,
    darkModeState: false,
    locationFinderState: { lat: 35.7247, lon: 51.4067 },
    deleteButonId: [],
    DataState: false,
    errorState: "",
    selectSearchState: "",
    version:"",
    searchSelectOption:""
};

export const HandleSlice = createSlice({
    name: "counter",
    initialState,
    reducers: {
        handleHambergerState: (state, action) => {
            state.hambergerState = action.payload;
        },
        handleLoadingSpinner: (state, action) => {
            state.loadingSpinnerState = action.payload;
        },
        handlePopperState: (state, action) => {
            state.popperState = action.payload;
        },
        handleDeleteButtonDisplayState: (state, action) => {
            state.DeleteButtonDisplayState = action.payload;
        },
        dashboardPageDataHandle: (state, action) => {
            state.dashboardPageData = action.payload;
        },
        skeletonHandler: (state, action) => {
            state.skeletonState = action.payload;
        },
        pathNameHandler: (state, action) => {
            state.pagesPathName = action.payload;
        },

        searchInputValue: (state, action) => {
            state.setInputValue = action.payload;
        },
        handleKeyOfInputForSearch: (state, action) => {
            state.KeyOfInputForSearch.push(action.payload);
        },
        handleSingleKey: (state, action) => {
            state.singleKey = action.payload;
        },
        handleToastifyType: (state, action) => {
            state.toastifyType = action.payload;
        },
        handleconnectionFailed: (state, action) => {
            state.conectionFailedState = action.payload;
        },
        handleExpireState: (state, action) => {
            state.expireState = action.payload;
        },
        handleTableSkeleton: (state, action) => {
            state.tableSkeleton = action.payload;
        },
        handleHomeAdminFetch: (state, action) => {
            state.homeAdminFetchState = action.payload;
        },
        handleRemoveSearchExist: (state, action) => {
            state.removeSearchExist = action.payload;
        },
        handleDarkMode: (state, action) => {
            state.darkModeState = action.payload;
        },
        handlelocationFinder: (state, action) => {
            state.locationFinderState = action.payload;
        },
        handleDeleteButton: (state, action) => {
            state.deleteButonId = action.payload;
        },
        handelDataState: (state, action) => {
            state.DataState = action.payload
        },
        handleErrorState: (state, action) => {
            state.errorState = action.payload
        },
        handleSelectSearchState: (state, action) => {
            state.selectSearchState = action.payload
        },
        setVersionHandler:(state,action)=>{
            state.version = action.payload
        },
        setSearchSelectOption:(state,action)=>{
            state.searchSelectOption = action.payload
        }
    },
});

export const {
    handleSelectSearchState,
    handleErrorState,
    handleHambergerState,
    handleLoadingSpinner,
    handlePopperState,
    handleDeleteButtonDisplayState,
    dashboardPageDataHandle,
    skeletonHandler,
    pathNameHandler,
    searchInputValue,
    handleKeyOfInputForSearch,
    handleSingleKey,
    handleToastifyType,
    handleconnectionFailed,
    handleExpireState,
    handleTableSkeleton,
    handleHomeAdminFetch,
    handleRemoveSearchExist,
    handleDarkMode,
    handlelocationFinder,
    handleDeleteButton,
    handelDataState,
    setVersionHandler,
    setSearchSelectOption
} = HandleSlice.actions;

export default HandleSlice.reducer;
